import * as yup from 'yup';

let roleValidationForm = yup.object().shape({
  role: yup.string().required("Name is required"),
})

export {
  roleValidationForm
}